import React, { ElementType } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import BaseInputText from '../InputText';
import BaseInputColor from '../InputColor';
import BaseInputRadio from '../InputRadio';

import { IDispatch } from '../../../../../modules/stores';
import { ISpace, BackgroundType } from '../../../../../types/space';

type IConnectProps = ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  space: ISpace<ElementType>;
}

const BackgroundConfigs = ({ space, updateSpaceConfig, intl: { formatMessage } }: IProps) => {
  const BACKGROUND_OPTIONS = [
    {
      value: BackgroundType.Transparent,
      name: formatMessage({ id: 'sidebar.background.transparent' }),
    },
    {
      value: BackgroundType.Filled,
      name: formatMessage({ id: 'sidebar.background.filled' }),
    },
  ];

  return (
    <>
      <BaseInputRadio
        name="background"
        setFn={(val: BackgroundType) => {
          updateSpaceConfig({
            id: space.id,
            updates: { background: val },
          });
        }}
        options={BACKGROUND_OPTIONS}
        title={formatMessage({ id: 'sidebar.background' })}
        value={space.config.background}
      />
      {space.config.background === BackgroundType.Filled && (
        <BaseInputColor
          name="backgroundColor"
          setFn={(val: string) => {
            updateSpaceConfig({
              id: space.id,
              updates: { backgroundColor: val },
            });
          }}
          type="text"
          value={space.config.backgroundColor || ''}
        />
      )}
      <BaseInputText
        name="padding"
        setFn={(val: number) => {
          updateSpaceConfig({
            id: space.id,
            updates: { padding: Number(val) },
          });
        }}
        title={formatMessage({ id: 'sidebar.padding' })}
        type="number"
        value={space.config.padding}
      />
      <BaseInputText
        name="borderRadius"
        setFn={(val: number) => {
          updateSpaceConfig({
            id: space.id,
            updates: { borderRadius: Number(val) },
          });
        }}
        title={formatMessage({ id: 'sidebar.borderRadius' })}
        type="number"
        value={space.config.borderRadius}
      />
    </>
  );
};

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpaceConfig: (payload: any) => space.updateSpaceConfig(payload),
});

export default compose(
  injectIntl,
  connect(
    () => ({}),
    // @ts-ignore
    mapDispatch,
  ),
)(BackgroundConfigs);
